module.exports = __webpack_public_path__ + "img/first-board-created.30b9c514.png";